/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentation`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展示`)
};

/**
* | output |
* | --- |
* | "Presentation" |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_0 as "gc.search_guides.gridcraft_vs_excel.sections.5.table.rows.1.0" }